import { apiClient } from './apiClient';
import { roleServiceMock } from './roleService.mock';
import type {
  Role,
  RoleListItem,
  RoleRateHistory,
  RoleAuditLog,
  AuditLogQuery,
} from '@/types/role';
import type { DataMode } from '@/contexts/DataSourceContext';

const realRoleService = {
  // Role read operations
  async getAllRoles(): Promise<RoleListItem[]> {
    return await apiClient.get<RoleListItem[]>(`/roles`);
  },

  async getActiveRoles(): Promise<RoleListItem[]> {
    return await apiClient.get<RoleListItem[]>(`/roles/active`);
  },

  async getRoleById(id: number): Promise<Role> {
    return await apiClient.get<Role>(`/roles/${id}`);
  },

  // Rate operations
  async getRateHistory(roleId: number): Promise<RoleRateHistory[]> {
    return await apiClient.get<RoleRateHistory[]>(`/roles/${roleId}/rates/history`);
  },

  // Audit operations
  async getAuditLogs(query: AuditLogQuery): Promise<RoleAuditLog[]> {
    const params = new URLSearchParams();
    if (query.entityType) params.append('entityType', query.entityType);
    if (query.entityId) params.append('entityId', query.entityId.toString());
    if (query.startDate) params.append('startDate', query.startDate);
    if (query.endDate) params.append('endDate', query.endDate);
    if (query.changedBy) params.append('changedBy', query.changedBy);
    if (query.pageNumber) params.append('pageNumber', query.pageNumber.toString());
    if (query.pageSize) params.append('pageSize', query.pageSize.toString());

    return await apiClient.get<RoleAuditLog[]>(`/roles/audit-logs?${params.toString()}`);
  },
};

// Get the appropriate role service based on the data mode
export const getRoleService = (mode: DataMode) => {
  return mode === 'live' ? realRoleService : roleServiceMock;
};
